/** @jsx jsx */
import { UserAvatar, UserAvatarProps } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { useAttachmentQuery } from "@/data/attachments";
import { UserBase } from "@/data/users";

interface LazyUserAvatarProps extends UserAvatarProps {
  user: UserBase;
}

export const LazyUserAvatar: FC<LazyUserAvatarProps> = ({ user, ...avatarProps }) => {
  const { data } = useAttachmentQuery(user.avatar);

  return (
    <UserAvatar
      firstName={user.firstName ?? undefined}
      lastName={user.lastName ?? undefined}
      img={data?.publicUrl ?? undefined}
      {...avatarProps}
    />
  );
};
